module.exports = __webpack_public_path__ + "static/img/ic_photo.d928ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_photo.png
// module id = fxfG
// module chunks = 1